module.exports = __webpack_public_path__ + "img/intersect.a8ac6579.png";